import { render, staticRenderFns } from "./ServiceHelp.vue?vue&type=template&id=91b0aa26&"
import script from "./ServiceHelp.vue?vue&type=script&lang=js&"
export * from "./ServiceHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91b0aa26')) {
      api.createRecord('91b0aa26', component.options)
    } else {
      api.reload('91b0aa26', component.options)
    }
    module.hot.accept("./ServiceHelp.vue?vue&type=template&id=91b0aa26&", function () {
      api.rerender('91b0aa26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wWRAnooEJZqu/JS/comp/ServiceHelp.vue"
export default component.exports